import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  Avatar,
  Skeleton,
} from "@mui/material";
import freeVoteIcon from "../../../assets/customerAssets/icons/voteIcon.svg";
import freeVoteIconV from "../../../assets/customerAssets/freeVotesIcon.svg";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addVote } from "../../../api/addClubVote";
import { getGoalVotes } from "../../../api/getGoalVote";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const VoteComponent = ({ vote, id, count, setTournamentData }) => {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gcount, setCount] = useState(count);
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const handleClicked = async () => {
    try {
      if (user.data.is_skip) {
        navigate("/register");
        return;
      }
      setLoading(true);
      if (token && user.data.id) {
        const data = await addVote(user.data.id, id, token);
        if (data.success) {
          setCount((v) => v + 1);
          setTournamentData((data) => {
            const newGoals = data?.tournamentGoalVideos?.map((data) =>
              data.id == id
                ? { ...data, voteCount: data.voteCount + 1, hasVoted: 1 }
                : data,
            );
            const rankedGoals = newGoals?.sort((a, b) =>
              a.voteCount > b.voteCount ? -1 : 1,
            );
            return { ...data, tournamentGoalVideos: rankedGoals };
          });

          setLoading(false);
          setClicked(true);
          dispatch({ type: "DCREMENT_VOTE" });
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{ display: "flex", alignItems: "center" }}
        className="user_vote_component"
      >
        <Button className="icon-div" onClick={handleClicked}>
          {loading ? (
            <Skeleton animation="wave" height={27} width={27} />
          ) : (
            <img
              src={vote || clicked ? freeVoteIconV : freeVoteIcon}
              className="iconImg"
            />
          )}
        </Button>
      </Box>
    </>
  );
};

export default VoteComponent;
